import { useIntl, FormattedMessage } from "react-intl";
import Screen from "../screen";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AppError } from "../../../model/AppError";
import { Collapse } from "react-bootstrap";
import "./error-screen-view.scss";

//<editor-fold desc="Props">
export interface ErrorScreenErrorProps {
  showError: boolean;
  onShowError: (b: boolean) => void;
}
export interface ErrorScreenProps extends ErrorScreenErrorProps {
  errors?: AppError<any>[];
}
//</editor-fold>
export default function ErrorScreen(props: ErrorScreenProps) {
  const intl = useIntl();
  const { errors, showError, onShowError } = props;
  return (
    <Screen
      id={"error-screen"}
      data-test-error-screen
      meta={{
        title: intl.formatMessage({
          defaultMessage: "Authentication failed",
          description:
            "Heading for the authorization error screen. This screen is shown after a failed login attempt or login status check.",
        }),
        description: intl.formatMessage({
          defaultMessage: "Authentication failure info page.",
          description:
            "window meta description for the authorization error screen",
        }),
      }}
      icon={
        <FontAwesomeIcon
          icon={"exclamation-triangle"}
          className={"icon"}
          size="4x"
        />
      }
      header={
        <h1>
          <FormattedMessage
            defaultMessage="Oh no!"
            description="heading for the authorization error screen"
          />
        </h1>
      }
      footer={
        <a
          className={"btn btn-lg btn-block btn-primary"}
          href={process.env.PUBLIC_URL + "/"}
        >
          <FormattedMessage
            defaultMessage="Continue"
            description={"continue button label"}
          />
        </a>
      }
    >
      <p>
        <FormattedMessage
          defaultMessage="Something went wrong and authentication has failed. Please try again."
          description="message for the authorization error screen"
        />
      </p>
      <div className={"details"}>
        <button
          className={"btn btn-light btn-block" + (showError ? " active" : "")}
          data-test-error-details-trigger
          onClick={(e: any) => {
            onShowError(!showError);
          }}
        >
          <FormattedMessage
            defaultMessage="{isVisible, select, true {Hide} false {Show} other {Toggle} } technical error details"
            description={
              "Toggle error details button label. 'isVisible' = state of target"
            }
            values={{ isVisible: showError }}
          />
        </button>
        <Collapse in={showError} data-test-error-details>
          <div className={"collapsible-target"}>
            {errors &&
              (errors as AppError<any>[]).map((err) => {
                return <p>{err.apiError.error_description}</p>;
              })}
          </div>
        </Collapse>
      </div>
    </Screen>
  );
}
